import { render } from "./Detail503.vue?vue&type=template&id=f9eaa7e4&scoped=true"
import script from "./Detail503.vue?vue&type=script&lang=js"
export * from "./Detail503.vue?vue&type=script&lang=js"

import "./Detail503.vue?vue&type=style&index=0&id=f9eaa7e4&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\moolng-cms-parent\\moolng-lunzhongyi-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9eaa7e4"]])

export default __exports__